var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.url,"alt":_vm.$t('title.photo')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }